module.exports = __webpack_public_path__ + "static/media/registro.bbb6d34a.png";